import { SolutionSessionId } from '@backrs_ui/grow-ui/src/models/models';

export const sessionNames: Record<SolutionSessionId, string> = {
  resume_builder: 'Resume Builder',
  'resume_builder.education': 'Resume Builder',
  'resume_builder.work_experience': 'Resume Builder',
  'resume_builder.leadership': 'Resume Builder',
  'resume_builder.skills': 'Resume Builder',
  default: 'Session',
} as const;

export const boxTitles: Record<SolutionSessionId, string[]> = {
  resume_builder: [],
  'resume_builder.education': [],
  'resume_builder.work_experience': [],
  'resume_builder.leadership': [],
  'resume_builder.skills': [],
  default: ['Preferences', 'Profile'],
};
